export default __webpack_public_path__ + "static/assets/MPK_Header.4bda4f3ad3a4b07d49e7bc8056157699.png";